import AppConfig from './DataAppConfig';

const RollbacksAppConfig = [AppConfig];

export default RollbacksAppConfig;
